const login = () => import(/* webpackPrefetch: true */ '@/views/public/index.vue')
const base64 = () => import(/* webpackPrefetch: true */ '@/views/public/base64.vue')

const routes = [
  {
    path: "/login",
    name: "login",
    component: login,
    meta: {
      title: "Masuk"
    }
  },
  {
    path: "/base64",
    name: "base64",
    component: base64,
    meta: {
      title: "Base64"
    }
  }
]
export default routes.map(route => {
  const meta = {
    all: false, 
    public: true,
    onlyLoggedOut: true,
    title: route.meta.title
  }
  return { ...route, meta }
})